import { render } from "./SolicitudMostrarComponent.vue?vue&type=template&id=0e7c531a"
import script from "./SolicitudMostrarComponent.vue?vue&type=script&lang=js"
export * from "./SolicitudMostrarComponent.vue?vue&type=script&lang=js"

import "./SolicitudMostrarComponent.vue?vue&type=style&index=0&id=0e7c531a&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__